import React from 'react';

import classnames from 'classnames/bind';
import styles from './pagingNumber.module.scss';
const cx = classnames.bind(styles);

interface IInfoPagingNumberProps {
  isEmpty: boolean;
  currentPage: number;
  totalPageNum: number;
  handlePagingClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

const MAX_PAGING_NUM = 5;

const PagingNumber = ({ isEmpty, currentPage, totalPageNum, handlePagingClick }: IInfoPagingNumberProps) => {
  const diff = totalPageNum - currentPage;
  const pagingList: number[] = [];

  const range = (start: number, length: number): number[] => {
    if (length < 1) {
      return [];
    }
    return Array.from({ length }, (_, index) => index + start);
  };

  if (isEmpty) {
    return (
      <a className={cx('pagingNum', 'selected')} role="button">
        1
      </a>
    );
  }

  // 이전 페이지 담기
  const maxPrevious = diff > 2 ? 2 : MAX_PAGING_NUM - diff;
  range(1, maxPrevious)
    .reverse()
    .map((it) => {
      const pagingNum = currentPage - it;
      if (pagingNum >= 0) {
        pagingList.push(pagingNum);
      }
    });

  // 현재 페이지 담기
  pagingList.push(currentPage);

  // 이후 페이지 담기
  const maxNext = MAX_PAGING_NUM - pagingList.length;
  range(1, maxNext).map((it) => {
    const pagingNum = currentPage + it;
    if (pagingNum < totalPageNum) pagingList.push(currentPage + it);
  });

  return (
    <div className={cx('pagingNumArea')}>
      {pagingList.map((it, index) => (
        <a
          key={index}
          className={cx('pagingNum', { selected: currentPage === it })}
          role="button"
          onClick={handlePagingClick}
        >
          {it + 1}
        </a>
      ))}
    </div>
  );
};

export default PagingNumber;
